import React from 'react';
import { getStatusDisplay } from '../../../../../services/trips/utils/tripUtils';
import './StatusBadge.css';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const displayText = getStatusDisplay(status);

  return (
    <div className={`status-badge ${className}`}>
      {displayText}
    </div>
  );
};

export default StatusBadge;

